export default __webpack_public_path__ + "static/media/lilac.8889e2c9.png";